<template>
  <i :class="set + ' fa-' + type"/>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    set: {
      type: String,
      default: 'fa'
    },
    type: {
      type: String,
      default: 'exclamation-triangle'
    }
  }
}
</script>
